<template>
  <v-sheet color="grey-darken-4" theme="dark">
    <v-container>
      <v-row>
        <v-col>
          <h5 class="text-h4 font-weight-bold mb-3">
            Our #1 goal is customer satisfaction.
          </h5>

          <ul class="text-body-1 ml-6 mb-3">
            <li>We do work for ALL insurance companies</li>
            <li class="text-uppercase">Limited lifetime warranty</li>
            <li>Local complimentary taxi/Lyft transportation</li>
            <li>State of the art equipment</li>
            <li>Electronic estimating</li>
            <li>Friendly, knowledgeable staff</li>
            <li>FREE estimates</li>
          </ul>

          <p class="text-body-1 mb-3">
            Whether you've been in a major accident or a minor fender bender,
            West Wind Automotive is the shop for you.
          </p>

          <p class="text-body-1 mb-3">
            <a
              class="text-white"
              href="http://maps.google.com/maps/place?cid=14363840956675673418&amp;q=west+wind+automotive&amp;gl=us"
              target="_blank"
              >Visit</a
            >
            or
            <a
              class="text-white"
              :href="`mailto:${infoEmail}?subject=Estimate inquiry`"
              >email us</a
            >
            today to get an estimate and learn more about our quality services!
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card
            :prepend-icon="mdiClockTimeEightOutline"
            color="blue-grey-darken-2"
            tile
          >
            <template #title
              ><span class="text-wrap"
                >Open Monday - Friday, 8:00 am - 5:00 pm. Closed Satuday and
                Sunday.</span
              >
            </template>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card
            :style="{ border: `1px solid ${colors.red.darken4}` }"
            class="pa-2"
            tile
            variant="flat"
          >
            <v-card-title>Did you know? </v-card-title>
            <v-card-text class="text-body-1">
              By law you have the right to choose your own body shop in the
              event of an accident. Don’t let the insurance company send you to
              a discounted shop. Get your car repaired right
              <span class="font-weight-bold text-red">the first time</span>
              at West Wind Automotive.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
import colors from 'vuetify/util/colors'
import { mdiClockTimeEightOutline } from '@mdi/js'

const infoEmail = import.meta.env.VITE_EMAIL
</script>
